// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { FileFragment } from '../../files/graphql/FileFragment.generated';
import { gql } from '@apollo/client';
import { FileFragmentDoc } from '../../files/graphql/FileFragment.generated';
export type DocumentEntity_EntityFragment = { __typename?: 'Entity', id: string, extendedDisplayKind: string, subtype: { __typename?: 'CCorpBusinessEntity', displayName: string, id: string } | { __typename?: 'CLTTrust', displayName: string, id: string } | { __typename?: 'CRTTrust', displayName: string, id: string } | { __typename?: 'CustodialPersonalAccount', displayName: string, id: string } | { __typename?: 'DonorAdvisedFund', displayName: string, id: string } | { __typename?: 'GPBusinessEntity', displayName: string, id: string } | { __typename?: 'GRATTrust', displayName: string, id: string } | { __typename?: 'ILITTrust', displayName: string, id: string } | { __typename?: 'IndividualPersonalAccount', displayName: string, id: string } | { __typename?: 'InsurancePersonalAccount', displayName: string, id: string } | { __typename?: 'IrrevocableTrust', displayName: string, id: string } | { __typename?: 'JointPersonalAccount', displayName: string, id: string } | { __typename?: 'LLCBusinessEntity', displayName: string, id: string } | { __typename?: 'LPBusinessEntity', displayName: string, id: string } | { __typename?: 'PrivateFoundation', displayName: string, id: string } | { __typename?: 'QPRTTrust', displayName: string, id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', displayName: string, id: string } | { __typename?: 'RetirementPersonalAccount', displayName: string, id: string } | { __typename?: 'RevocableTrust', displayName: string, id: string } | { __typename?: 'SCorpBusinessEntity', displayName: string, id: string } | { __typename?: 'SLATTrust', displayName: string, id: string } | { __typename?: 'SoleProprietorshipBusinessEntity', displayName: string, id: string }, defaultDocument?: { __typename?: 'Document', id: string } | null };

export type DocumentTestamentaryEntity_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string };

export type DocumentFragment = { __typename?: 'Document', createdAt: Time, createdBy: string, displayType: string, name: string, type: Types.DocumentType, updatedAt: Time, tenantID: string, id: string, household: { __typename?: 'Household', id: string }, file: (
    { __typename?: 'File' }
    & FileFragment
  ), pdfFile?: (
    { __typename?: 'File' }
    & FileFragment
  ) | null, user: { __typename?: 'User', id: string }, defaultDocumentOfEntity?: { __typename?: 'Entity', id: string } | null, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, suggestionPrecedenceOrder?: number | null, entity?: (
          { __typename?: 'Entity' }
          & DocumentEntity_EntityFragment
        ) | null, testamentaryEntity?: (
          { __typename?: 'TestamentaryEntity' }
          & DocumentTestamentaryEntity_TestamentaryEntityFragment
        ) | null } | null } | null> | null }, lifetimeExclusionEvent?: Array<{ __typename?: 'LifetimeExclusionEvent', id: string, eventDate: Time, giftAmount?: CurrencyUSD | null, kind: Types.LifetimeExclusionEventKind, grantor: { __typename?: 'ClientProfile', id: string, displayName: string } }> | null };

export const Operations = {
  Fragment: {
    DocumentEntity_Entity: 'DocumentEntity_Entity' as const,
    DocumentTestamentaryEntity_TestamentaryEntity: 'DocumentTestamentaryEntity_TestamentaryEntity' as const,
    Document: 'Document' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DocumentEntity_EntityFragmentDoc = gql`
    fragment DocumentEntity_Entity on Entity {
  id
  extendedDisplayKind
  subtype {
    displayName
    id
  }
  defaultDocument {
    id
  }
}
    `;
export const DocumentTestamentaryEntity_TestamentaryEntityFragmentDoc = gql`
    fragment DocumentTestamentaryEntity_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on Document {
  household {
    id
  }
  createdAt
  createdBy
  displayType
  file {
    ...File
  }
  pdfFile {
    ...File
  }
  user {
    id
  }
  name
  type
  updatedAt
  tenantID
  defaultDocumentOfEntity {
    id
  }
  entityDocumentRelationships {
    edges {
      node {
        id
        relationshipType
        suggestionPrecedenceOrder
        entity {
          ...DocumentEntity_Entity
        }
        testamentaryEntity {
          ...DocumentTestamentaryEntity_TestamentaryEntity
        }
      }
    }
  }
  lifetimeExclusionEvent {
    id
    eventDate
    grantor {
      id
      displayName
    }
    giftAmount
    kind
  }
  id
}
    ${FileFragmentDoc}
${DocumentEntity_EntityFragmentDoc}
${DocumentTestamentaryEntity_TestamentaryEntityFragmentDoc}`;